import { render, staticRenderFns } from "./DokmanComponentOptionenMitarbeiter.vue?vue&type=template&id=45013b2c"
import script from "./DokmanComponentOptionenMitarbeiter.vue?vue&type=script&lang=js"
export * from "./DokmanComponentOptionenMitarbeiter.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentOptionenMitarbeiter.vue?vue&type=style&index=0&id=45013b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports